const update = {
    TITLE: "اینستا کاتالوگ به نسخه جدید بروزرسانی شد",
    VERSION: "تغییرات نسخه ",
    PUBLISH_DATE:"تاریخ انتشار: ",
    OK_BTN:'حله، دمت گرم'
}

export default update